import DriveFileMoveIcon from '@mui/icons-material/DriveFileMove';
import Button from '../../common/Button.component';

const MoveToButton = ({
  onClick = () => {},
  label,
  disabled = false,
  ...props
}) => {
  return (
    <Button
      variant='contained'
      startIcon={<DriveFileMoveIcon />}
      onClick={disabled ? () => {} : () => onClick()}
      sx={{ backgroundColor: '#1d80d2ff' }}
      disabled={disabled}
      {...props}
    >
      {label}
    </Button>
  );
};

export default MoveToButton;
